export default {
  equipments: [],
}
